'use client'

import RouterButton from '@snowball-tech/common/components/RouterButton'
import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import { usePathname } from 'next/navigation'

export default function UpsellButton() {
  const pathname = usePathname()
  const $t = useTranslations()

  if (pathname === '/snowball-plus' || pathname === '/snowball-max') {
    return null
  }

  return (
    <RouterButton
      href="/snowball-plus?origin=header"
      label={$t('header.upgrade.plus.label')}
      variant="display"
    />
  )
}
